export const CLOUDIA_SERVICES: {
  [key: string]: { port: number; basePath: string; endpoints: string[] };
} = {
  business_management: {
    port: 8086,
    basePath: 'businessService',
    endpoints: [
      '/allocations',
      '/costCenters',
      '/projectCustomers',
      '/projects',
      '/costCenterUsers',
      '/projectCategories',
      '/staticObjects',
      '/tasks',
      '/currencyConverter',
      '/competenceDomain',
      '/skill',
      '/certificate',
      '/specialization',
      '/title',
      '/gradematrix',
      '/cv-issues',
      '/resources',
      '/allocation-logs',
      '/settings',
      '/national-holidays',
      '/tenants',
      '/customerPortals',
      '/reported-hours',
      '/workBlockers',
    ],
  },
  SEARCH_ENGINE: {
    port: 8093,
    basePath: 'searchEngine',
    endpoints: [
      '/consultantSearch',
      '/bookingRequest',
      '/comment',
      '/recreateCv',
      '/cvstudio',
    ],
  },
  DOCUMENT_MANAGEMENT: {
    port: 8090,
    basePath: 'documentService',
    endpoints: [
      '/activityExecutions',
      '/documents',
      '/documentsUsers',
      '/select-fetch',
      '/workflow',
    ],
  },
  EMPLOYEE_MANAGEMENT: {
    port: 8084,
    basePath: 'employeeService',
    endpoints: [
      '/absences',
      '/employees',
      '/employee-education',
      '/employeeCertificates',
      '/equipment',
      '/timesheet',
      '/certificates',
      '/holidays',
      '/knowledgeSharing',
      '/timelogs',
      '/specializationEmployee',
      '/knowledgeSharingType',
      '/skillEmployees',
      '/employeeLanguages',
      '/csatEmployees',
      '/employeeCv',
      '/projectExperience',
      '/career',
    ],
  },
  GRADE_MATRIX_MANAGEMENT: {
    port: 8092,
    basePath: 'gradeService',
    endpoints: ['/gradeMatrixScore', '/gradeMatrixUser'],
  },
  USER_MANAGEMENT: {
    port: 8080,
    basePath: 'usersService',
    endpoints: ['/users', '/customerUsers', '/kc', '/usersInfo'],
  },
  NOTIFICATION_MANAGEMENT: {
    port: 8080,
    basePath: 'notificationService',
    endpoints: ['/notifications-template', '/notifications'],
  },
  ORCHESTRATOR_MANAGEMENT: {
    port: 8083,
    basePath: 'orchestratorService',
    endpoints: ['/itbm'],
  },
  CSAT_MANAGEMENT: {
    port: 8080,
    basePath: 'csatService',
    endpoints: ['/csat'],
  },
  RANKING: {
    port: 8100,
    basePath: 'cvranks',
    endpoints: ['/cvranks', '/servicenowagent'],
  },
  AI_ASSISTANT: {
    port: 8099,
    basePath: 'aiService',
    endpoints: ['/ai'],
  },
};
